/* eslint-disable import/no-anonymous-default-export */
/*
    Customer Dashboard Reducer
    
*/
import { NotificationManager } from "react-notifications";
import { createContextHash, getContextObject } from "../helpers/helpers";
import _ from "lodash";
import moment from "moment";
import {
  CHANGE_DOMAIN,
  EXECUTE_PAYMENT,
  EXECUTE_PAYMENT_FAILURE,
  EXECUTE_PAYMENT_SUCCESS,
  FILTER_CUSTOMER_CONSENT_REPORT,
  GET_CHANNEL_COUNT_REPORT,
  GET_CHANNEL_COUNT_REPORT_FAILURE,
  GET_CHANNEL_COUNT_REPORT_SUCCESS,
  GET_CONSENT_CHECK_COUNT_FAILURE,
  GET_CONSENT_CHECK_COUNT_SUCCESS,
  GET_COST_PER_ACTIVITY_FAILURE,
  GET_COST_PER_ACTIVITY_SUCCESS,
  GET_COST_PER_CONTACT_FAILURE,
  GET_COST_PER_CONTACT_SUCCESS,
  GET_CUSTOMER_CONSENT_REPORT,
  GET_CUSTOMER_CONSENT_REPORT_FAILURE,
  GET_CUSTOMER_CONSENT_REPORT_SUCCESS,
  GET_CUSTOMER_CONSUMER_REPORT,
  GET_CUSTOMER_CONSUMER_REPORT_FAILURE,
  GET_CUSTOMER_CONSUMER_REPORT_SUCCESS,
  GET_CUSTOMER_EVENT_REPORT,
  GET_CUSTOMER_EVENT_REPORT_FAILURE,
  GET_CUSTOMER_EVENT_REPORT_SUCCESS,
  GET_CUSTOMER_LEDGER_REPORT,
  GET_CUSTOMER_LEDGER_REPORT_FAILURE,
  GET_CUSTOMER_LEDGER_REPORT_SUCCESS,
  GET_CUSTOMER_LIST,
  GET_CUSTOMER_LIST_FAILURE,
  GET_CUSTOMER_LIST_SUCCESS,
  REFUND_PAYMENT,
  REFUND_PAYMENT_FAILURE,
  REFUND_PAYMENT_SUCCESS,
  SELECT_CUSTOMER,
  SELECT_CUSTOMER_DOMAIN,
  SELECT_CUSTOMER_DOMAIN_FAILURE,
  SELECT_CUSTOMER_DOMAIN_SUCCESS,
} from "../actions/types";
// initial state
const INIT_STATE = {
  profileData: { Daywise: [], aggregatedData: [] },
  cmpData: { Daywise: [], aggregatedData: [] },
  consentdata: [],
  filteredConsentdata: [],
  consumerdata: [],
  eventsdata: [],
  ledgerdata: [],
  channelCount: [],
  audienceCount: 0,
  customers: [],
  selectedCustomer: null,
  selectedCustomerDomain: null,
  loading: false,
  payment: null,
  refundTransaction: null,
  activityCosts: null,
  contactCosts: null,
  consentChecks: null,
  domainReport: null,
  selectedCustomerDomainForEvent: null,
  filterModel: {
    type: "hour",
    text: "Last 12 hours",
    value: 12,
  },
  reportType: null,
  profilesStats: {
    new: 0,
    revisits: 0,
    updates: 0,
  },
  domainStats: [],
  browserStats: [],
  noDataStatus: false,
  consentFilterDays: 1,
  consentFilterDomain: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get non draft campaigns from server.
    case GET_CUSTOMER_EVENT_REPORT:
      return { ...state, loading: true };
    // On Success...
    case GET_CUSTOMER_EVENT_REPORT_SUCCESS:
      var events = [];
      if (action.payload.data) {
        events = JSON.parse(action.payload.data);
      }
      return { ...state, loading: false, eventsdata: events };
    // On Failure, show error message.
    case GET_CUSTOMER_EVENT_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Get non draft campaign stats from server.
    case GET_CUSTOMER_LEDGER_REPORT:
      return { ...state, loading: true };
    // On Success...
    case GET_CUSTOMER_LEDGER_REPORT_SUCCESS:
      var ledger = [];
      if (action.payload.data) {
        ledger = JSON.parse(action.payload.data);
      }

      return { ...state, loading: false, ledgerdata: ledger };
    // On Failure, show error message.
    case GET_CUSTOMER_LEDGER_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_CUSTOMER_LIST:
      return { ...state };
    case GET_CUSTOMER_LIST_SUCCESS:
      return { ...state, customers: action.payload.data };
    case GET_CUSTOMER_LIST_FAILURE:
      return { ...state };
    case SELECT_CUSTOMER:
      let usercontext = getContextObject();
      // if context exists
      if (usercontext) {
        usercontext.customerId = action.payload.id;
        // refresh hash of the context and store it in sessionStorage
        createContextHash(usercontext);
      } else {
        var context = {
          isPartner: false,
          customerId: action.payload.id,
        };
        // create hash of the context and store it in sessionStorage
        createContextHash(context);
      }

      return {
        ...state,
        selectedCustomer: action.payload,
        reportType: null,
        selectedCustomerDomain: action.payload.domains[0],
        selectedCustomerDomainForEvent: action.payload.domains[0],
        eventsdata: [],
        ledgerdata: [],
        domainReport: null,
      };
    case EXECUTE_PAYMENT:
      return { ...state, loading: true, payment: action.payload };
    case EXECUTE_PAYMENT_SUCCESS:
      NotificationManager.success("Your payment was successful");
      return { ...state, loading: false, payment: null };
    case EXECUTE_PAYMENT_FAILURE:
      NotificationManager.error(
        "We count not process your payment, please try again later."
      );
      return { ...state };
    case REFUND_PAYMENT:
      return { ...state, loading: true, refundTransaction: action.payload };
    case REFUND_PAYMENT_SUCCESS:
      NotificationManager.success("Transaction was refunded successfully.");
      return { ...state, loading: false, refundTransaction: null };
    case REFUND_PAYMENT_FAILURE:
      NotificationManager.error(
        "We count not process refund, please try again later."
      );
      return { ...state, loading: false, refundTransaction: null };
    // Get channel count from server.
    case GET_CHANNEL_COUNT_REPORT:
      return { ...state, loading: true };
    // On Success...
    case GET_CHANNEL_COUNT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        channelCount: action.payload.data.result.channelCounts,
        audienceCount: action.payload.data.result.userCount,
      };
    // On Failure, show error message.
    case GET_CHANNEL_COUNT_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Get channel count from server for selected Domain.
    case SELECT_CUSTOMER_DOMAIN:
      return {
        ...state,
        loading: true,
        selectedCustomerDomain: action.payload,
      };
    // On Success...
    case SELECT_CUSTOMER_DOMAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        channelCount: action.payload.data.result.channelCounts,
        audienceCount: action.payload.data.result.userCount,
      };
    // On Failure, show error message.
    case SELECT_CUSTOMER_DOMAIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    // On Success...
    case GET_COST_PER_ACTIVITY_SUCCESS:
      var activity = null;
      if (action.payload.data) {
        activity = JSON.parse(action.payload.data);
      }
      return { ...state, loading: false, activityCosts: activity };
    // On Failure, show error message.
    case GET_COST_PER_ACTIVITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        activityCosts: null,
      };

    case GET_COST_PER_CONTACT_SUCCESS:
      return { ...state, loading: false, contactCosts: action.payload.data };
    // On Failure, show error message.
    case GET_COST_PER_CONTACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        contactCosts: null,
      };

    case GET_CONSENT_CHECK_COUNT_SUCCESS:
      return { ...state, loading: false, consentChecks: action.payload.data };
    // On Failure, show error message.
    case GET_CONSENT_CHECK_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        consentChecks: null,
      };

    case CHANGE_DOMAIN:
      return { ...state, selectedCustomerDomainForEvent: action.payload };

    // Get customer consent stats from server.
    case GET_CUSTOMER_CONSENT_REPORT:
      return {
        ...state,
        loading: true,
        reportType: 2,
        dates: action.payload,
      };
    // On Success...
    case GET_CUSTOMER_CONSENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        cmpData: action.payload.data,
      };

    // On Failure, show error message.
    case GET_CUSTOMER_CONSENT_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        consentdata: [],
        filteredConsentdata: [],
      };

    case FILTER_CUSTOMER_CONSENT_REPORT:
      var filterDomain = action.payload;
      var data = null;
      if (filterDomain !== "") {
        data = _.filter([...state.consentdata], { domain: filterDomain });
      } else {
        data = state.consentdata;
      }

      return {
        ...state,
        loading: false,
        error: action.payload,
        filteredConsentdata: data,
        consentFilterDomain: filterDomain,
      };
    // Get customer consumer data stats from server.
    case GET_CUSTOMER_CONSUMER_REPORT:
      return { ...state, loading: true, reportType: action.payload };
    // On Success...
    case GET_CUSTOMER_CONSUMER_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        profileData: action.payload.data,
      };

    // On Failure, show error message.
    case GET_CUSTOMER_CONSUMER_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
      };

    default:
      return { ...state, loading: false };
  }
};
